import * as core from '../../../../../../../core'

import { query } from './save-external-institution.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.actions.save-external-institution',
    description: 'Save External Institution',
    name: 'Save External Institution',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
